import { observer } from 'mobx-react';
import useAsyncEffect from 'use-async-effect';
import { useNavigate, } from 'react-router-dom';
import ApplyViewModel from './ApplyViewModel';
import { Appl } from '../../../../core/Appl';
const InitApp = observer(() => {
  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  vm.navigate = useNavigate();

  useAsyncEffect(async () => {
    await vm.validateAndVerifyUrl(document.location.href);
  }, []);

  return (
    <>
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Caller: {document.location.href} */}
      </div>
    </>
  );
});

export default InitApp;
